<template>
    <div :class="['droparea', direction && `droparea--${direction}`]">
        <div
            :class="['droparea__popup', draggingCounter > 0 ? 'droparea__popup--active' : '']"
            v-if="uploadingProcess === ''"
        >
            <div class="droparea__dropfield" @dragover="handleDragOver" @drop="handleDrop">
                <div class="droparea__choose-file">
                    <img src="@/assets/svg/paperclip.svg" alt />
                    <b>Przeciągnij pliki lub foldery tutaj</b>
                </div>
            </div>
        </div>

        <div class="droparea__uploading" v-else-if="uploadingProcess === 'during' || uploadingProcess === 'completed'">
            <div class="droparea__group" v-for="(group, index) in fileGroups" :key="group.id">
                <h4 class="droparea__group-name">Grupa {{ index + 1 }}</h4>
                <div
                    v-for="file in group.uploadingFiles"
                    :key="file.id"
                    :class="[
                        'attachment__file',
                        file.progress === 100 ? 'attachment__file--uploaded' : '',
                        file.progress === 'faild' ? 'attachment__file--error' : '',
                    ]"
                >
                    <div class="attachment__icon"><IconFile /></div>
                    <div class="attachment__content">
                        <h3 class="attachment__filename">{{ file.fileName }}</h3>
                        <span class="attachment__filepath">
                            Lokalizacja: <b>{{ file.fullPath }}</b>
                        </span>
                    </div>

                    <div class="progress-bar">
                        <div class="progress-bar__bar" :style="{ width: file.progress + '%' }"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="droparea__stats" v-if="fileGroups.length">
            <h3>Informacje o wybranych plikach:</h3>

            <div class="droparea__uploading-stats" v-if="uploadingProcess === ''">
                <div class="attachment__file">
                    <div class="attachment__icon"><IconFileTree /></div>
                    <div class="attachment__content">
                        <h3 class="attachment__filename">Grupy plików: {{ fileGroups.length }}</h3>
                    </div>
                </div>

                <div class="attachment__file">
                    <div class="attachment__icon"><IconFile /></div>
                    <div class="attachment__content">
                        <h3 class="attachment__filename">Wszystkie pliki: {{ filesTotal.selected }}</h3>
                    </div>
                </div>

                <div class="info">
                    <h4 class="info__title">Uwaga!</h4>
                    <p class="info__content">
                        Po rozpoczęciu przesyłania nie będzie można dodać ani usunąć żadnych plików!
                    </p>
                </div>

                <a @click="startUploadingProcess" class="btn droparea__start-upload">Rozpocznij przesyłanie</a>
            </div>

            <div v-else class="droparea__uploading-stats">
                <div :class="['attachment__file', countUploadedGroups() === fileGroups.length ? 'attachment__file--uploaded' : '',]">
                    <div class="attachment__icon"><IconFileTree /></div>
                    <div class="attachment__content">
                        <h3 class="attachment__filename">
                            Grupy plików: <br />
                            {{ countUploadedGroups() }} / {{ fileGroups.length }}
                        </h3>
                        <div class="progress-bar">
                            <div
                                class="progress-bar__bar"
                                :style="{ width: countProgressbarWidth(countUploadedGroups(), fileGroups.length) }"
                            ></div>
                        </div>
                    </div>
                </div>
                <div :class="['attachment__file', uploadCompleted() ? 'attachment__file--uploaded' : '']">
                    <div class="attachment__icon"><IconFile /></div>
                    <div class="attachment__content">
                        <h3 class="attachment__filename">
                            Wszystkie pliki: <br />
                            {{ filesTotal.uploaded }} / {{ filesTotal.selected }}
                            [{{ parseFloat((filesTotal.uploaded / filesTotal.selected) * 100).toFixed(2)}}%]
                        </h3>
                        <div class="progress-bar">
                            <div
                                class="progress-bar__bar"
                                :style="{ width: countProgressbarWidth(filesTotal.uploaded, filesTotal.selected) }"
                            ></div>
                        </div>
                    </div>
                </div>
                <div v-if="uploadingProcess === 'completed'" class="form__success">Przesyłanie zostało zakończone</div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { IconFile, IconFileTree } from "./icons";

export default {
    data() {
        return {
            draggingCounter: 0,
            uploadingProcess: "",
            fileGroups: [],
            filesTotal: {
                selected: 0,
                uploaded: 0,
            },
            dirsTotal: {
                selected: 0,
            },
            refreshTokenInterval: () => "",
            chunkSize: 6,
        };
    },
    props: {
        folderId: {
            type: String,
            required: true,
        },
        direction: {
            type: String,
            required: false,
        },
    },
    computed: mapGetters({
        securedRequestHeader: "getSecuredRequestHeader",
    }),
    components: {
        IconFile,
        IconFileTree,
    },
    methods: {
        countUploadedGroups() {
            return this.fileGroups.filter((g) => g.status === "completed").length;
        },
        countProgressbarWidth(current, total) {
            return (current * 100) / total + "%";
        },
        handleDragOver(e) {
            e.stopPropagation();
            e.preventDefault();
            e.dataTransfer.dropEffect = "copy";
        },
        handleDrop(e) {
            e.stopPropagation();
            e.preventDefault();

            this.draggingCounter = 0;
            this.$emit("updateStatus", "selected");

            const groupId = Math.round(Date.now() * Math.random());
            const files = e.dataTransfer.items;

            this.fileGroups.push({
                id: groupId,
                status: "ready",
                files: [],
                uploadingFiles: [],
            });

            for (let i = 0; i < files.length; i++) {
                const item = files[i].webkitGetAsEntry();
                if (item) this.countFiles(item, groupId);
            }
        },

        readEntriesAsync(reader) {
            return new Promise((resolve, reject) => {
                reader.readEntries(
                    (entries) => {
                        resolve(entries);
                    },
                    (error) => reject(error)
                );
            });
        },

        async enumerateDirectoryWithManyFiles(directoryEntry) {
            let reader = directoryEntry.createReader();
            let resultEntries = [];

            let read = async () => {
                let entries = await this.readEntriesAsync(reader);
                if (entries.length > 0) {
                    resultEntries = resultEntries.concat(entries);
                    await read();
                }
            };

            await read();
            return resultEntries;
        },

        fileAsPromise(entry) {
            return new Promise((resolve, reject) => {
                entry.file(resolve, reject);
            });
        },

        countFiles(item, groupId, path = "") {
            if (item.isFile) {
                this.filesTotal.selected++;
                this.fileGroups.find((g) => g.id === groupId).files.push({ fileEntry: item, path });
            } else if (item.isDirectory) {
                this.dirsTotal.selected++;
                this.enumerateDirectoryWithManyFiles(item).then((entries) => {
                    entries.map((entry) => this.countFiles(entry, groupId, path + item.name + "/"));
                });
            }
        },
        async startUploadingProcess() {
            this.uploadingProcess = "during";
            this.$emit("updateStatus", this.uploadingProcess);

            for (const fileGroup of this.fileGroups) {
                const fileChunks = fileGroup.files
                    .map((e, i) => {
                        return i % this.chunkSize === 0 ? fileGroup.files.slice(i, i + this.chunkSize) : null;
                    })
                    .filter((e) => e);

                for (const chunk of fileChunks) {
                    await Promise.all(
                        chunk.map(async (fileInfo) => {
                            let file = await this.fileAsPromise(fileInfo.fileEntry);

                            file.fullPath = fileInfo.fileEntry.fullPath;

                            await this.prepareFile(file, fileGroup);
                        })
                    );
                }
            }
        },

        async getUploadUrl(file) {
            const { name, type, fullPath } = file;
            const uploadUrl = `${process.env.VUE_APP_API_URL}/amazon/s3/folder/${this.folderId}/files/${name}`;
            const response = await axios.post(
                uploadUrl,
                {
                    fullPath,
                },
                {
                    headers: this.securedRequestHeader,
                    params: {
                        mimeType: type,
                    },
                }
            );
            return response.data;
        },
        async prepareFile(file, fileGroup) {
            const { id, url } = await this.getUploadUrl(file);

            fileGroup.uploadingFiles.push({
                id: id,
                fileName: file.name,
                fullPath: file.fullPath,
                progress: 0,
            });

            return this.uploadFile(url, id, fileGroup, file);
        },
        async uploadFile(url, id, fileGroup, file) {
            try {
                await axios
                    .put(url, file, {
                        onUploadProgress: (progressEvent) => {
                            const progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                            fileGroup.uploadingFiles.find((el) => el.id === id).progress = progress;
                        },
                    })
                    .then(() => {
                        this.filesTotal.uploaded++;

                        fileGroup.uploadingFiles.find((el) => el.id === id).progress = 100;
                        const uploadedFiles = fileGroup.uploadingFiles.filter((el) => el.progress === 100).length;

                        if (uploadedFiles === fileGroup.files.length) {
                            fileGroup.status = "completed";
                        }
                    });
            } catch (error) {
                this.uploadingFiles.find((el) => el.id === id).progress = "faild";
                console.error(new Error(error));
            }
        },

        uploadCompleted() {
            if (this.filesTotal.uploaded === this.filesTotal.selected) {
                this.uploadingProcess = "completed";

                this.$store.commit("updateAttachments", {
                    folderId: this.folderId,
                    folderFilesCount: this.filesTotal.uploaded,
                });

                this.$emit("updateStatus", "completed");

                return true;
            }
            return false;
        },
        uploadInProgress() {
            return this.uploadingProcess !== "" && this.uploadingProcess !== "completed";
        },
        preventNav(event) {
            if (!this.uploadInProgress()) return;
            event.preventDefault();
            event.returnValue = "";
        },
    },
    mounted() {
        const app = document.querySelector("#app");
        app.addEventListener("dragenter", () => this.draggingCounter++);
        app.addEventListener("dragleave", () => this.draggingCounter--);

        // prevent the token from expiring during uploading
        const tokenExpireIn = process.env.VUE_APP_TOKEN_EXPIRE_IN;
        const refreshTokenDelay = (tokenExpireIn - tokenExpireIn * 0.1) * 1000;

        this.refreshTokenInterval = setInterval(() => {
            this.$store.dispatch("refreshUserToken");
        }, refreshTokenDelay);
    },
    beforeMount() {
        clearInterval(this.refreshTokenInterval);

        window.addEventListener("beforeunload", this.preventNav);
        this.$once("hook:beforeDestroy", () => {
            window.removeEventListener("beforeunload", this.preventNav);
        });
    },
};
</script>

<style lang="scss">
.droparea {
    $this: &;
    padding: 20px 0;
    display: flex;
    justify-content: center;

    &__popup {
        max-width: 800px;
        flex: 2;

        &--active {
            position: fixed;
            left: 15px;
            top: 15px;
            width: calc(100% - 30px);
            height: calc(100% - 30px);
            z-index: 999;
            background: #fff;
            box-shadow: 0 0 50px rgba(#000, 0.2);
            display: flex;
            border-radius: 25px;
            max-width: unset;
            .droparea__dropfield {
                margin: 15px;
                border: 3px dashed rgba(#85b904, 0.2);
                flex: 1;
                font-size: 25px;
                img {
                    width: 30px;
                }
            }
        }
    }

    &__stats {
        flex: 1;
        padding: 0 20px;
        h3 {
            margin-top: 0;
        }
    }

    &__dropfield {
        min-height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        margin: auto;
        border: 2px dashed #e1e1e1;
        border-radius: 10px;
        text-align: center;
        position: relative;
    }

    &__choose-file {
        display: flex;
        align-items: center;
        justify-content: center;
        b {
            margin-left: 12px;
        }
    }

    &__uploading {
        max-height: 400px;
        box-sizing: border-box;
        padding: 10px;
        margin: 0 auto;
        overflow: auto;
        border: 2px solid #f1f1f1;
        border-radius: 10px;
        flex: 2;
        &-stats {
            .attachment__file {
                max-width: 100%;
                margin: -1px 0;
            }
            .form__success {
                margin-top: 20px;
            }
        }
    }
    &__group {
        padding: 10px;
        &-name {
            margin: 0;
            padding: 10px;
        }
    }

    &__start-upload {
        width: 100%;
        box-sizing: border-box;
        margin: 0 !important;
    }
}

.attachment {
    $this: &;
    &__file {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 6px;
        border: solid #f1f1f1;
        border-width: 1px 0;
        margin-top: -1px;
        box-sizing: border-box;

        #{$this}__icon {
            max-width: 40px;
            min-width: 40px;
            height: 40px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            background: rgba(#1ea3ad, 0.2);
            color: #1ea3ad;
            margin-right: 10px;
            text-transform: uppercase;
            font-weight: bold;
            font-size: 12px;
            svg {
                width: 20px;
            }
        }
        #{$this}__content {
            flex: 1;
        }
        #{$this}__filename {
            font-size: 14px;
            color: #9e9e9e;
            margin: 0;
        }
        #{$this}__filepath {
            font-size: 12px;
            color: #9e9e9e;
            line-height: 1;
        }

        &--uploaded,
        &--error {
            .progress-bar {
                display: none;
            }
            #{$this}__filename {
                color: #616161 !important;
            }
        }
        &--uploaded {
            #{$this}__icon {
                background: rgba(#85b904, 0.2);
                color: #85b904;
            }
        }
        &--error {
            #{$this}__icon {
                background: rgba(#f44336, 0.2);
                color: #f44336;
            }
        }
    }
}

.progress-bar {
    position: relative;
    background: #e5e5e5;
    height: 7px;
    border-radius: 10px;
    margin-top: 4px;
    width: 100%;

    &__bar {
        height: 7px;
        left: 0;
        top: 0;
        position: absolute;
        background: #85b904;
        box-shadow: 0 5px 14px -2px rgba(133, 185, 4, 0.8);
        border-radius: 10px;
        transition: width 500ms;
    }
}
</style>
